module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-view"
  }, [_c('canvas', {
    ref: "canvas",
    attrs: {
      "height": _vm.height,
      "width": _vm.width
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31bcfeea","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/charts/Chart.vue
// module id = 530
// module chunks = 0